

type dowloadFileDocProps = {
  url: string;
  method?: 'GET' | 'POST';
  body?: any
  nameFile?: string;
  extensionFile?: string;
}
export const useFileDowloadDoc = () => {
  //function
  const downloadFile = async (
    {
      url,
      nameFile = "archivo",
      //extensionFile = "pdf",
      extensionFile,
      method = 'GET',
      body,
    }: dowloadFileDocProps
  ) => {
    try {
      const response = await fetch(url,{
        method,
        headers:{
          'Content-Type': 'application/json'
        },
        body: method === "POST"? JSON.stringify(body): undefined

      });

      if (!response.ok) throw new Error("No se puso descargar el archivo");
      
      const blob = await response.blob();
      
      ///******************detecta desde el servidor si no viene especificado
      const tipoContenido = response.headers.get("Content-Type") || "";
      const extensionCapturado = tipoContenido.split("/")[1] || "bin"

      const finalExtension = extensionFile || extensionCapturado
      
      //const finalExtension = ext
      const downloadUrl = window.URL.createObjectURL(blob);

      const link = document.createElement("a")
      link.href = downloadUrl;
      link.download = `${nameFile}.${finalExtension/* extensionFile */}`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      window.URL.revokeObjectURL(downloadUrl);
    } catch (error) {
      console.error("error al descargar")
    }
  }
  return {
    downloadFile,
  }
}